/**
 * @generated SignedSource<<9aa5b4a15d9f638864a4369168ad48d0>>
 * @relayHash 32a01b8f12b42ca5d907577c94d87dae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b40861b4339cb380f89d76ee305ccecf99bce3bc0f64b37ab9d39f885dfd647e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueArchiveAsyncInput = {
  jql: string;
};
export type services_archiveIssueAsyncMutation$variables = {
  cloudId: string;
  input: JiraIssueArchiveAsyncInput;
};
export type services_archiveIssueAsyncMutation$data = {
  readonly jira_archiveIssueAsync: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: "JiraIssueArchiveAsyncErrorExtension";
        readonly statusCode: number | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type services_archiveIssueAsyncMutation = {
  response: services_archiveIssueAsyncMutation$data;
  variables: services_archiveIssueAsyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "services_archiveIssueAsyncMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssueArchiveAsyncPayload",
        "kind": "LinkedField",
        "name": "jira_archiveIssueAsync",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "type": "JiraIssueArchiveAsyncErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "services_archiveIssueAsyncMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssueArchiveAsyncPayload",
        "kind": "LinkedField",
        "name": "jira_archiveIssueAsync",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "JiraIssueArchiveAsyncErrorExtension"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b40861b4339cb380f89d76ee305ccecf99bce3bc0f64b37ab9d39f885dfd647e",
    "metadata": {},
    "name": "services_archiveIssueAsyncMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3af36fc47648106921125d68205d3207";

export default node;
